import { CopyToClipboard } from "Components/Shared/CopyToClipboard";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { LinkDisplay } from "Components/Shared/LinkDisplay/LinkDisplay";
import { Resources, useResource } from "Translations/Resources";
import { Box, Skeleton, Typography, Stack } from "@mui/material";

const RESOURCES = Resources.Components.Affiliate.AffiliateLink;

type Props = {
  affiliateCodeUrl?: string;
  isLoading?: boolean;
};

export const AffiliateLink = ({
  affiliateCodeUrl,
  isLoading = false,
}: Props) => {
  const { t } = useResource();

  if (isLoading) {
    return <AffiliateLinkSkeleton />;
  }

  if (!affiliateCodeUrl) {
    return <ErrorText>{t(RESOURCES.LoadingError)}</ErrorText>;
  }

  return (
    <Stack gap={2}>
      <Typography fontWeight={600}>{t(RESOURCES.Title)}</Typography>
      <LinkDisplay>
        <Box component="code" flex={1} sx={{ lineBreak: "anywhere" }}>
          {affiliateCodeUrl}
        </Box>
        <CopyToClipboard
          text={affiliateCodeUrl}
          accessibilityLabel={t(RESOURCES.CopyLink)}
          successMessage={t(RESOURCES.LinkCopied)}
        />
      </LinkDisplay>
    </Stack>
  );
};

export const AffiliateLinkSkeleton = () => {
  const { t } = useResource();

  return (
    <Stack gap={2}>
      <Typography fontWeight={600}>{t(RESOURCES.Title)}</Typography>
      <Skeleton height={70} variant="rounded" />
    </Stack>
  );
};
